import { uid } from "@wx/lib-state";
import { getAreaId } from "../../helpers";
export default function (store, { id, columnId, rowId, before, source }) {
    if (!columnId) {
        return;
    }
    const nextState = {
        dragItemsCoords: null,
        dragItemId: null,
        before: null,
        overAreaId: null,
        areasMeta: {},
    };
    const { areasMeta, cardsMeta } = store.getState();
    const overAreaId = getAreaId(columnId, rowId);
    if (overAreaId && id) {
        const area = areasMeta[overAreaId];
        const { columnId, rowId } = area;
        if (source.length > 1) {
            const batchId = uid();
            source.forEach(id => {
                store.in.exec("move-card", {
                    id,
                    columnId,
                    rowId,
                    before,
                    $meta: {
                        batch: batchId,
                    },
                });
                const meta = cardsMeta[id];
                if (meta) {
                    meta.dragging = false;
                }
            });
        }
        else {
            store.in.exec("move-card", {
                id,
                columnId,
                rowId,
                before,
            });
            const meta = cardsMeta[id];
            if (meta) {
                meta.dragging = false;
            }
        }
    }
    nextState.cardsMeta = cardsMeta;
    const updatedAreasMeta = store.getState().areasMeta;
    Object.keys(updatedAreasMeta).forEach(key => {
        nextState.areasMeta[key] = {
            ...updatedAreasMeta[key],
            height: null,
        };
    });
    store.setState(nextState);
}
//# sourceMappingURL=end.js.map